export default __webpack_public_path__ + "static/media/Ellipse 17.dfc090ae.png";